module.exports = __webpack_public_path__ + "img/ioc_512x512.6718984f.png";